import React, { useEffect, useState, useContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import "./PromotersList.css";
import PromotersListRequests from "./PromotersListRequests";
import PromotersFormModal from "../form/PromotersFormModal";
import { Button } from "react-bootstrap";
import ModalConfirmation from "../../../Layout/Modals/ModalConfirmation";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../../../../components/NavBar";
import { useRef } from "react";
import { Grid } from "../../../Layout/Grid/GridView";

const PromotersList = () => {
  const gridRef = useRef();
  let params = useParams();
  const [data, setData] = useState([]);
  const [venuesList, setVenuesList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const handleModalShow = () => setModalShow(true);
  const handleModalHide = () => {
    handlerRequestList();
    setModalShow(false);
  };

  const PromotersTable = () => {
    const ActionColumn = (e) => {
      return (
        <div>
          <Button
            variant="danger btn-sm"
            onClick={() => handlerDeletPromoterConfirmation(e.data.id)}
          >
            <i className="fa-solid fa-trash"></i>&nbsp; Eliminar
          </Button>
        </div>
      );
    };

    const StatusColumn = (e) => {
      return (
        <div className={`status-column ${e.data.status.toString().toLowerCase()}`}>
          {e.data.status}
        </div>
      );
    };

    return (
      <Grid
        ref={gridRef}
        rows={data}
        cols={[
          { hide: true, field: "id" },
          { headerName: "Nome", field: "name" },
          { headerName: "Spot", field: "venue" },
          {
            headerName: "Estado",
            field: "status",
            cellRenderer: StatusColumn,
          },
          {
            headerName: "Eliminar",
            cellClass: "actions-button-cell",
            cellRenderer: ActionColumn,
          },
        ]}
      />
    );
  };





  const handlerRequestList = async () => {
    let info = await PromotersListRequests.getPromotersList(params);
    if (info && info.status) {
      setData(info.data.list);
      setVenuesList(info.data.venues);
    }
  };

  useEffect(() => {
    document.title = "Promoters | Nightspot Dashboard";
    handlerRequestList();
  }, []);

  const [modalConfirmationState, setModalConfirmationState] = useState({
    isVisible: false,
    param: 0,
  });
  const handleShowModalConfirmation = (obj) =>
    setModalConfirmationState({
      isVisible: true,
      param: obj,
    });
  const handleHideModalConfirmation = () =>
    setModalConfirmationState({
      isVisible: false,
      param: 0,
    });
  const handlerDeletPromoterConfirmation = (param) => {
    handleShowModalConfirmation(param);
  };

  const handlerDeletePromoter = async (id) => {
    let info = await PromotersListRequests.deletePromoter({ id: id });
    if (info) {
      if (info.status === true) {
        handlerRequestList();
      } else {
        toast.error(info.errors, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
      handleHideModalConfirmation();
    }
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            <div className="row">
              <div className="col-8">
                <h2 className="dashboard-h2">Lista de Promotores</h2>
              </div>
              <div className="col-4 ">
                <div
                  className="btn btn-primary float-end"
                  onClick={handleModalShow}
                >
                  <i className="fa-solid fa-plus"></i>&nbsp;Adicionar
                </div>
                <Link
                  className="btn btn-primary me-2 float-end"
                  to="/my/promoters/stats"
                >
                  <i className="fa-solid fa-chart-line"></i>&nbsp;Estatísticas
                </Link>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/my/dashboard">
                        <i className="fa-solid fa-home"></i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Lista de Promotores
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="row">
              <div className="col-12 event-list-table">
                <PromotersTable />
              </div>
            </div>
          </div>
        </div>
        {/* <ToastContainer /> */}
        <PromotersFormModal
          show={modalShow}
          handleModalShow={() => setModalShow(true)}
          handleModalhide={() => handleModalHide(false)}
          venuesList={venuesList}
        />
        <ModalConfirmation
          show={modalConfirmationState.isVisible}
          param={modalConfirmationState.param}
          handleModalhide={handleHideModalConfirmation}
          handleModalConfirm={(param) => handlerDeletePromoter(param)}
          text="Tem a certeza de que pretende apagar este registo?"
        />
      </NavBar>
    </div>
  );
};

export default PromotersList;
